export default "__VITE_ASSET__Dhbx0nmF__"